import { FileCheck2, CircleAlert } from 'lucide-react'
import { Chip } from './Chip'
import { idLine, prdpLine, uberLine, type ScreeningFields, type ScreeningLine } from '../../utils/screening'

// The document reader's verdict on the PrDP and the Uber profile, so the
// manager sees it before and during the interview. `compact` shows the chips
// only (worklist cards); the full form adds what to ask about each.
export function ScreeningChips({ app, compact = false }: { app: ScreeningFields; compact?: boolean }) {
  const lines = [prdpLine(app), idLine(app), uberLine(app)].filter((l): l is ScreeningLine => l !== null)
  return (
    <div className="space-y-1.5">
      <div className="flex flex-wrap gap-1.5">
        {lines.map((l) => (
          <Chip
            key={l.label}
            tone={l.tone}
            icon={l.tone === 'green' ? <FileCheck2 className="h-3 w-3" /> : <CircleAlert className="h-3 w-3" />}
          >
            {l.label}
          </Chip>
        ))}
      </div>
      {!compact &&
        lines
          .filter((l) => l.action)
          .map((l) => (
            <p key={`${l.label}-action`} className="text-xs text-muted-foreground">
              <span className="font-medium text-foreground">{l.label}: </span>
              {l.action}
            </p>
          ))}
      {!compact && app.uber_evidence && (
        <p className="text-xs text-muted-foreground">
          <span className="font-medium text-foreground">What the Uber screenshot shows: </span>
          {app.uber_evidence}
        </p>
      )}
    </div>
  )
}
